var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{class:{'error': _vm.errors.length > 0},attrs:{"type":_vm.type,"id":_vm.idAttr,"name":_vm.nameAttr,"maxlength":_vm.maxlength},domProps:{"value":_vm.value},on:{"input":function (e) { _vm.$emit('input', e.target.value) },"focus":function (e) { _vm.$emit('focus', e) }}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5d73348","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/forms/registration-form/TextInput.vue
// module id = null
// module chunks = 